import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {PublicationAccessService} from "../../landing-publication/publication-access.service";
import {environment} from "environments/environment";
import {UserService} from "app/core/user/user.service";
import {PublicationMessagesService} from "../../landing-publication/publication-messages.service";

@UntilDestroy()
@Component({
    selector: 'app-publication-debug',
    templateUrl: './publication-debug.component.html',
    styleUrls: ['./publication-debug.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PublicationDebugComponent implements OnInit {

    clientAppUrl = environment.clientAppUrl;

    publicationUuid: string;
    editPublicationLink: string;

    extValuesPerGroup = {};

    electedGroupIndex: string[] = [];

    debugInfos: any = {};

    surveyIds: string[] = [];

    // <!--            "sqlRule": "(\n               2610_22293\n                !=\n                '** NOT SET FOR USER **' ) AND (\n                joyce_random\n                =\n                '1' )",-->
    // <!--            "comId": 1075,-->
    // <!--            "publicationUuid": "ecded93d-1911-41c9-9f60-a0b705f198ed",-->
    // <!--            "groupId": "78b78114-92a5-4eaa-bd3f-e6f42e563449",-->
    // <!--            "groupTitle": "A répondu au 2610",-->
    // <!--            "fields": [-->
    // <!--            "2610_22293",-->
    // <!--            "joyce_random"-->
    // <!--            ],-->


    evalResultDebug: {
        sql2: any,
        sql3: {
            result: {
                sqlRule: string;
                comId: number,
                publicationUuid: string,
                groupId: string,
                groupTitle: string,
                fields: string[],
            }[],
        },
        sqlFake?: {
            result: {
                pubUuid: string;
                groupId: string;
            }[]
        },
    };

    constructor(
        public userService: UserService,
        public publicationAccessService: PublicationAccessService,
        public publicationMessagesService: PublicationMessagesService,
        private cdr: ChangeDetectorRef,
    ) {
    }

    ngOnInit(): void {



        this.publicationAccessService.debugInfos$.pipe(untilDestroyed(this)).subscribe((debugInfo) => {

            // console.log('-->', debugInfo.publication.surveys.ids);
            this.surveyIds = debugInfo.publication?.surveys?.ids || [];


            this.publicationUuid = this.publicationAccessService.pubUuid;
            this.editPublicationLink = `${environment.clientAppUrl}/publications/edit/${this.publicationUuid}`

            this.debugInfos = debugInfo;

            this.evalResultDebug = debugInfo?.evaluation?.evalResult?.debugInfos;

            this.electedGroupIndex = [];

            this.evalResultDebug?.sql3?.result.forEach((aGroup) => {

                this.extValuesPerGroup[aGroup.groupId] = {};

                aGroup.fields.forEach((key) => {
                    this.extValuesPerGroup[aGroup.groupId][key] = this.userService.user.extProfiles?.[key] || '** NOT SET FOR USER **';
                });

            })

            this.evalResultDebug?.sqlFake?.result?.forEach((ar) => {
                this.electedGroupIndex.push(ar.groupId);
            })

            // console.log('Debug Info:', debugInfo);

            this.cdr.markForCheck();

        })

    }

    checkAgain() {
      this.publicationAccessService.evaluatePublicationRules()
    }

}
